import React from 'react';
import Button from '@atlaskit/button';
import { IconTile } from '@atlaskit/icon';
import BookWithBookmarkIcon from '@atlaskit/icon/core/book-with-bookmark';
import { Box, Inline, Text, xcss } from '@atlaskit/primitives';
var knowledgeBadgeStyles = xcss({
  display: 'inline-flex',
  border: "1px ".concat("var(--ds-border, #091E4224)", " solid"),
  borderRadius: 'border.radius.100',
  backgroundColor: 'color.background.input'
});
var buttonLinkStyles = xcss({
  padding: 'space.025',
  marginLeft: 'space.025',
  marginRight: 'space.050'
});
export var KnowledgeBadge = function KnowledgeBadge(_ref) {
  var name = _ref.name,
    url = _ref.url,
    _ref$onBadgeClick = _ref.onBadgeClick,
    onBadgeClick = _ref$onBadgeClick === void 0 ? function () {} : _ref$onBadgeClick;
  return /*#__PURE__*/React.createElement(Box, {
    xcss: knowledgeBadgeStyles
  }, /*#__PURE__*/React.createElement(Button, {
    href: url,
    appearance: "subtle",
    onClick: function onClick() {
      onBadgeClick();
    },
    spacing: "none",
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Inline, {
    space: "space.050",
    alignBlock: "center",
    xcss: buttonLinkStyles
  }, /*#__PURE__*/React.createElement(IconTile, {
    icon: BookWithBookmarkIcon,
    label: "",
    appearance: "blue",
    size: "16"
  }), /*#__PURE__*/React.createElement(Text, null, name))));
};